function getTimeStrip(interval) {
  if (interval !== null && interval !== void 0 && interval.start && interval !== null && interval !== void 0 && interval.end) {
    const {
      start,
      end
    } = interval;
    return `${start}-${end}`;
  }
  return '';
}

export { getTimeStrip };
//# sourceMappingURL=getTimeStrip.js.map
